import React from "react";
import { useParams } from "react-router-dom";

import {
  useQueryGetObjectivePath,
  useQueryGetObjectiveUsages,
} from "@examspark/common-app";
import { Text, VSpace } from "@examspark/common-ui";

import BrowseList from "../../components/browse/BrowseList";
import ObjectiveDetail from "../../components/ObjectiveDetail";

const StandardRoute = () => {
  const params = useParams<{
    id: string;
  }>();

  const { standardQuery } = useQueryGetObjectivePath(params.id);
  const { data: usages } = useQueryGetObjectiveUsages(standardQuery.data?.id);

  return (
    <VSpace size="3rem">
      <ObjectiveDetail objective={standardQuery.data} />
      <VSpace size="2rem">
        <Text.H2>Used in Units / Modules</Text.H2>
        <BrowseList data={usages?.items ?? []} />
      </VSpace>
    </VSpace>
  );
};

export default StandardRoute;
